<template>
  <section class="page-container">
    <h1>Partnership Inquiries</h1>
    <div class="filter-container">
      <div class="flex">
        <div class="filter-box">
          <span class="label">Search</span>
          <div class="search-box">
            <v-input
              v-model="search"
              placeholder="Company Name, BR Number, Contact Person, Email, Phone"
              @keyEnter="filterData" />
          </div>
        </div>
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        class="table-pointer"
        @row-click="rowClick">
        <el-table-column
          prop="id"
          label="ID"></el-table-column>
        <el-table-column
          prop="company_name"
          label="Company Name"></el-table-column>
        <el-table-column
          prop="business_registration_no"
          label="BR Number"></el-table-column>
        <el-table-column
          prop="business_nature"
          label="Business Nature"></el-table-column>
        <el-table-column
          prop="person_name"
          label="Person In Charge Name"></el-table-column>
        <el-table-column
          prop="person_email"
          label="Email"></el-table-column>
        <el-table-column
          prop="person_phone"
          label="Mobile Number"></el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import { getPartnershipList } from '@/api/partnership'
import {mapActions, mapState} from 'vuex'
export default {
  name: 'Partnership',
  mixins: [MixinOptions],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      search: '',
      tableData: []
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        let {ship={}} =  this.selectFilterData||{}
        Object.keys(ship).forEach(item=>{
          this[item] = ship[item]
        })
        this.setFilterData(ship||{})
        this.network().getPartnershipList()
      }
    }
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    rowClick(row) {
      let params = {
        pageConfig:this.pageConfig,
        search: this.search,
      }
      this.setFilterData({ship:params})

      this.$router.push({
        path: '/administration/partnership/detail',
        query: {
          partnership_id: row.id
        }
      })
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getPartnershipList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getPartnershipList()
    },
    network() {
      return {
        getPartnershipList: async () => {
          const { data } = await getPartnershipList({
            search: this.search,
            page: this.pageConfig.currentPage
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  h1 {
    // margin-bottom: 20px;
    font-size: 34px;
  }
 .filter-container {
    .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          font-weight: 400;
          font-weight: 500;
        }
      }
      .search-box {
          margin-right: 20px;
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
    }
  }
}
</style>
